import React, { useEffect, useState } from "react";
import axios from "axios";

function ModalRelatorios({ projetoId, onClose }) {
  const [relatorios, setRelatorios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    axios
      .get(`/api/relatorios/${projetoId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setRelatorios(res.data.Result || []);
      })
      .catch(() => setRelatorios([]))
      .finally(() => setLoading(false));
  }, [projetoId]);

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ background: "#00000099" }}
      role="dialog"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content rounded-4 shadow-lg border-0 bg-white p-4">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title">Relatórios do Projeto</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div
            className="modal-body"
            style={{ maxHeight: "60vh", overflowY: "auto" }}
          >
            {loading ? (
              <div>Carregando...</div>
            ) : relatorios.length === 0 ? (
              <div>Nenhum relatório encontrado.</div>
            ) : (
              <div className="row g-3">
                {relatorios.map((r) => (
                  <div className="col-12" key={r.id}>
                    <div className="card border-0 shadow-sm">
                      <div className="card-body">
                        <div className="d-flex justify-content-between mb-2">
                          <h6 className="card-title mb-0">{r.etapa}</h6>
                          <small>
                            {r.data_obs
                              ? new Date(r.data_obs).toLocaleDateString()
                              : "-"}
                          </small>
                        </div>
                        <div className="mb-1">
                          <strong>Situação:</strong> {r.situacao_etapa}
                        </div>
                        <div className="mb-1">
                          <strong>Observação:</strong> {r.observacao || "-"}
                        </div>

                        {r.inserido_por && (
                          <div className="mb-1">
                            <strong>Inserido por:</strong>
                            {r.nome_usuario || `(ID: ${r.inserido_por})`}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalRelatorios;
